import { ScribaInstance } from "scriba/Scriba";

const WithClient = (Component: any) => (props: any) => {

    const baseURL = ScribaInstance.getApiBaseUrl()
    const s3Bucket = ScribaInstance.getS3Bucket()
    return <Component {...props} clientBaseURL={baseURL} bucket={s3Bucket} />
}

export default WithClient;